import { questionCounter } from "./checkResult";
import displayQuestion from "./displayQuestion";
import { letters } from "../../index";
import { mainInput } from "../../index";

function displayLetter( nbr, nbr2 ){
  if ( nbr === 0 ){
    letters[nbr].style.display= 'block';
  }
  if ( nbr ) {
    letters[nbr].style.display= 'block';
  };
  if ( nbr2 ) {
    letters[nbr2].style.display= 'block';
  };
  mainInput.style.display= 'flex'
  mainInput.value = '';
  displayQuestion(questionCounter);
}

export default displayLetter;